import { Loader } from '../utils/loader'
import { SERVICES } from '../config/constants'

class PublicLoader extends Loader {}

export const publicLoader = new PublicLoader({
  service: SERVICES.pub
})
